jQuery(window).ready(function($) {
    // add accessibility slection status to accordion menu
    jQuery('li[role=treeitem]').attr('aria-selected', 'false');
    
	jQuery('body').on('mech|loadingstart', function() {
		console.log('show loading screen');
	});
	jQuery('body').on('mech|loadingcomplete', function() {
		console.log('hide loading screen');
	});
	jQuery('#menu-main-nav .menu').on('show.zf.dropdownMenu', function() {
		jQuery('.site-header').addClass('expanded');
	});
	jQuery('#menu-main-nav .menu').on('hide.zf.dropdownMenu', function() {
		jQuery('.site-header').removeClass('expanded');
	});

	/*
	// The audience needs to stay consistent based on the knowledge we have of the user.
	// If the user has committed to a particular segment (i.e., Business, Personal or Wealth Management),
	// that info is stored in a session variable and output to a hidden input variable
	*/
	function manageTopAudienceNav() {
		var currentNavItem = $('#menu-main-nav').find('.current-menu-item');
	
		if ( currentNavItem.length <= 0 ) {
			var currentString = $("#current-audience").val();
			if ('' !== currentString && $('.audience-nav-item.'+currentString).length > 0) {
				currentNavItem = $('.audience-nav-item.'+currentString);
				$(currentNavItem).addClass('current-menu-item').addClass('active');
			} else {
				currentNavItem = $('#menu-main-nav').first('.menu-item');
				$(currentNavItem).addClass('current-menu-item').addClass('active');
			}
		}	
	}
	
	function enableStickyTopNav() {
		var padding = 20;
		$(window).on('scroll', function() {
			if ($(window).scrollTop() >= padding) {
				$(".site-header").addClass('is-stuck');
			} else {
				$(".site-header").removeClass('is-stuck');
			}
		}).scroll();
	}
    
    // EXTERNAL LINKS (OPEN A CONFIRMATION/DISCLAIMER WINDOW)
    $.expr[':'].external = function(obj) {
        // gauntlet of whitelist exclusions
        var valid = true;
        valid = valid && !obj.href.match(/^#/);
        valid = valid && !obj.href.match(/^tel\:/);
        valid = valid && !obj.href.match(/secureinternetbank\.com/);
        valid = valid && !obj.href.match(/securebanksolutions\.com/);
        valid = valid && !obj.href.match(/myvirtualbranch\.com/);
        valid = valid && !obj.href.match(/chat.mymechanics\.com/);
        valid = valid && !obj.href.match(/wpengine\.netdna\-ssl\.com/);
        valid = valid && !obj.href.match(/mymechanics\.com/);
        valid = valid && (obj.hostname != location.hostname);
		valid = valid && !obj.className.match("chat-btn-inline");
        return valid;
    };
    function handleExternalLinks() {
        $('a:external').each(function() {
            var href = $(this).attr('href');
            if ( href.match(/^mailto\:/) ) {
                $(this).addClass('externalemail');
                $(this).click(function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        $('#external-email-prompt').foundation('open');
                        $('#external-email-url').attr('href', $(this).attr('href'));
               });
            } else {
                if (!$(this).hasClass("sistersite")) {
                    $(this).attr('target','_blank');
                    $(this).addClass('externallnk');
                    $(this).click(function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            $('#external-link-prompt').foundation('open');
                            $('#external-link-url').attr('href', $(this).attr('href'));
                   });
                }
            }
        });
    }
    $('#external-link-url').click(function(e) {
        $('#external-link-prompt').foundation('close');
    });
	
	enableStickyTopNav();
	manageTopAudienceNav();
    handleExternalLinks();
	
	// ONLINE LOGIN BUTTON
	/*
	$(".login-btn").click(function(e) {
		e.preventDefault();
		$(".online-banking-wrap").addClass('active');
	});
	$('.close-overlay').click(function(e){
		e.preventDefault();
		$(".online-banking-wrap").removeClass('active');
	});
	$('.online-banking .close').click(function(e){
		e.preventDefault();
		$(".online-banking-wrap").removeClass('active');
	});
    
    // PREVENT ONLINE BANKING FROM SUBMITTING TWICE
    // disable the button for 3 seconds
    $('#online-login').on('submit', function() {
       $(this).find('input.button').attr("disabled", true);
        setTimeout(function() {
            $('#online-login').find('input.button').removeAttr("disabled");
        }, 3000);
    });
	*/
	
	// CHAT LINK (OPEN IN NEW WINDOW)
	$('#chat-link').on('click', function(e) {
		e.preventDefault();
		$('#cloudlink-chat-overlay-contact-us-button').click();
		//var link = $(this).attr('href');
		//window.open(link, 'Mechanics Bank | Live Chat', 'height=700,width=376');
	});
	
	// SLICK CAROUSEL
	$('.slick-carousel').not('.slick-initialized').slick({
		responsive: [{
			breakpoint: 640,
			settings: "unslick"
		}]
	});
	
	$('.off-canvas-wrapper').on('opened.zf.offcanvas', function(e) {
		// expand the mobile menu to the current page
		var mobileMenu = $('#offCanvas .accordion-menu');
		$.each(mobileMenu.find('.is-accordion-submenu-parent.current-page-ancestor'), function(i,v) {
			if ($(this).children('ul').find('li.current-menu-item').length > 0) {
				console.log($(this).attr("id"));
				//$(mobileMenu).foundation('down', $(this).children('a'));
				$(this).attr('aria-expanded', true);
				$(this).children('ul').attr('aria-hidden', false).css('display', 'block');
			}
		});
		var currentMenuIsDropDown = $(mobileMenu).find('.is-accordion-submenu-parent.current-menu-item');
		if (currentMenuIsDropDown.length > 0) {
			console.log($(currentMenuIsDropDown).attr("id"));
			$(currentMenuIsDropDown).attr('aria-expanded', true);
			$(currentMenuIsDropDown).children('ul').attr('aria-hidden', false).css('display', 'block');
		}
	});
    
    // add paramters to YouTube Videos
   /*$('iframe').each(function() {
       var url = $(this).attr('src');
       if (url.indexOf('youtube') > 0) {
            $(this).attr("src",url.substring(0,url.indexOf('?')) + '?autohide=1&modestbranding=1&rel=0&showinfo=0&theme=light');   
       }
   });*/
    
    // REMOVE RELATED VIDEOS AUTOMATICALLY FROM YOUTUBE EMBEDS
    $('iframe[src*="youtube.com"]').each(function () {
        var sVideoURL = $(this).attr('src');
        console.log(sVideoURL);
        if (sVideoURL.indexOf('rel=0') == -1) {
            if (sVideoURL.indexOf('?') > 0) {
                $(this).attr('src', sVideoURL + '&rel=0');
            } else {
                $(this).attr('src', sVideoURL + '?rel=0');
            }
        }
    });
});